import React from 'react';
import './OfficeInfo.css';

const Insurances = () => {
    return (
        <section className="insurance-section">
            <span>INSURANCE COVERAGE</span>
            <h2>Insurances Accepted</h2>
            
            <div className="insurance-table">
                <div className="tbl-header">
                    <table>
                        <thead>
                            <tr>
                                <th>Insurance Provider</th>
                                <th>Plans Accepted</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div className="tbl-content">
                    <table>
                        <tbody>
                            <tr>
                                <td>Wellsense</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Medicare</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Health Plans Inc.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Harvard Pilgrim</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Wellpoint</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Mass General</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Railroad Medicine</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Cigna</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Tufts</td>
                                <td>Public, Commercial, Medicine</td>
                            </tr>
                            <tr>
                                <td>Fallon Health</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Blue Cross Blue Shield</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>TriCare</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Aetna</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>United Healthcare</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="infoinsurances">
                <h2>Important Information About Insurance Coverage</h2>
                <ul>
                    <li><strong>Verify Coverage:</strong> Please contact your insurance provider directly to verify your specific coverage and benefits before your appointment.</li>
                    <li><strong>Insurance Card Required:</strong> Bring your current insurance card to every appointment. Changes in insurance should be reported at least 24 hours prior to your visit.</li>
                    <li><strong>Referrals & Prior Authorizations:</strong> Some insurance plans may require referrals or prior authorizations for certain services. It's your responsibility to obtain these before your visit. Call the office with referral information if you have been seen about the issue. Please book an appointment to go over reasons for referrals.</li>
                    <li><strong>Payment Requirements:</strong> Co-payments and deductibles are due at the time of service. We accept cash, credit cards, and debit cards. Previous balances must be paid before or during your visit.</li>
                    <li><strong>Out-of-Network Services:</strong> If we are out-of-network with your insurance, you may be responsible for the full cost of services. Please verify network status with your insurance provider.</li>
                    <li><strong>Lab Work & Referrals:</strong> Some lab work and specialist referrals may require separate insurance verification. We recommend confirming coverage for these services in advance.</li>
                    <li><strong>Medicare Patients:</strong> Medicare patients should bring their Medicare card and any secondary insurance information. We accept Medicare assignment.</li>
                    <li><strong>Self-Pay Patients:</strong> Self-pay patients are required to pay the full amount at the time of service. We offer discounted rates for self-pay patients.</li>
                    <li><strong>Insurance Changes:</strong> If your insurance changes during the year, please notify us immediately and bring your new insurance card to your next appointment.</li>
                    <li><strong>Claims Processing:</strong> We will submit claims to your insurance provider on your behalf. However, you are ultimately responsible for any charges not covered by your insurance.</li>
                </ul>
            </div>
        </section>
    );
};

export default Insurances;
